import { useFormikContext } from 'formik';
import { RG, RadioGroupOption } from '@crazyegginc/hatch';

import { useEditorContext } from '../../editor-context';

export function ThemeSelector() {
  const { readonly } = useEditorContext();
  const { values, setFieldValue } = useFormikContext();
  const label = 'Theme';

  return (
    <div className="self-start">
      <div className="text-body-1 mb-2 block">{label}</div>
      <RG
        value={values.theme.dark}
        onChange={(newValue) => setFieldValue(`theme.dark`, newValue, true)}
        disabled={readonly}
        aria-label={label}
      >
        <div className="flex h-9 items-center justify-center space-x-2.5 rounded-full bg-white-lilac-500 px-2.5">
          <RadioGroupOption
            size="sm"
            labelClass="!ml-1.25"
            option={{ value: false, label: 'Light' }}
            disabled={readonly}
          />
          <RadioGroupOption
            size="sm"
            labelClass="!ml-1.25"
            option={{ value: true, label: 'Dark' }}
            disabled={readonly}
          />
        </div>
      </RG>
    </div>
  );
}
